"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

require("./Navigation.css");

var _react2 = require("@wwnds/react");

var _ButtonToolbar = _interopRequireDefault(require("react-bootstrap/ButtonToolbar"));

var _ButtonGroup = _interopRequireDefault(require("react-bootstrap/ButtonGroup"));

var _Alert = _interopRequireDefault(require("react-bootstrap/Alert"));

var _CompletedContext = _interopRequireDefault(require("./CompletedContext"));

var _Storage = require("./Storage");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Navigation = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Navigation, _Component);

  var _super = (0, _createSuper2.default)(Navigation);

  function Navigation(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Navigation);
    _this = _super.call(this, props);
    _this.state = {
      page: 0,
      pageCompleted: undefined,
      // Undefined: we don't know if it's true or false yet.
      completed: false
    };
    _this.previousPage = _this.previousPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.nextPage = _this.nextPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetPage = _this.resetPage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Navigation, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (this.state.page === this.props.children.length - 1 && this.state.pageCompleted && !this.state.completed) {
        this.setState({
          completed: true
        });
      }
    }
  }, {
    key: "previousPage",
    value: function previousPage() {
      this.setState({
        page: this.state.page - 1,
        pageCompleted: undefined
      });
      document.documentElement.tabIndex = 0;
      document.documentElement.focus();
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      this.setState({
        page: this.state.page + 1,
        pageCompleted: undefined
      });
      document.documentElement.tabIndex = 0;
      document.documentElement.focus();
    }
  }, {
    key: "resetPage",
    value: function resetPage() {
      (0, _Storage.clearStorage)();
      this.setState({
        page: 0,
        pageCompleted: undefined,
        completed: false
      });
      document.documentElement.tabIndex = 0;
      document.documentElement.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var showNext = this.state.pageCompleted && this.state.page < this.props.children.length - 1;
      var lastPanel = this.state.page === this.props.children.length - 1;
      return /*#__PURE__*/_react.default.createElement(_CompletedContext.default.Provider, {
        value: {
          onCompleted: function onCompleted(value, id) {
            console.log("navigation onCompleted", value);

            _this2.setState({
              pageCompleted: value
            });

            if (_this2.props.onPageCompleted) {
              _this2.props.onPageCompleted(value);
            }
          },
          registerPage: function registerPage() {
            console.log("Unhandled registerPage! in Navigation.jsx");
          },
          unregisterPage: function unregisterPage() {
            console.log("Unhandled unregisterPage! in Navigation.jsx");
          }
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "navigation",
        ref: this.ref
      }, this.props.children.map ? this.props.children.map(function (child, index) {
        if (index === _this2.state.page) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            key: "page",
            index: index
          });
        }

        return null;
      }) : this.props.children, /*#__PURE__*/_react.default.createElement(_ButtonToolbar.default, {
        className: "justify-content-between"
      }, /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, null, this.state.page > 0 && /*#__PURE__*/_react.default.createElement(_react2.Button, {
        className: "reset-button bdg-nav-button",
        variant: "solid",
        color: "gray",
        onClick: this.resetPage
      }, "Reset")), /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, null, this.state.page > 0 && /*#__PURE__*/_react.default.createElement(_react2.Button, {
        className: "prev-button bdg-nav-button",
        variant: "solid",
        color: "gray",
        onClick: this.previousPage
      }, "Previous"), !this.props.ghostMode && showNext && /*#__PURE__*/_react.default.createElement(_react2.Button, {
        className: "next-button bdg-nav-button",
        variant: "solid",
        color: "gray",
        onClick: this.nextPage
      }, "Next"), this.props.ghostMode && !lastPanel && /*#__PURE__*/_react.default.createElement(_react2.Button, {
        className: "next-button bdg-nav-button",
        variant: "solid",
        color: "gray",
        onClick: this.nextPage,
        disabled: !showNext
      }, "Next"))), this.state.pageCompleted && this.state.completed && /*#__PURE__*/_react.default.createElement(_Alert.default, {
        variant: "info",
        style: {
          textAlign: "center"
        }
      }, "Interactive complete")));
    }
  }]);
  return Navigation;
}(_react.Component);

exports.default = Navigation;